// extracted by mini-css-extract-plugin
export default {"container":"SuccessPage_container__OlmQ5","header":"SuccessPage_header__nykoJ","subHeader":"SuccessPage_subHeader__+SkWh","link":"SuccessPage_link__nLbA6"};